import { EventDetails } from './../../common/tracking/aws-tracker';
import { InsuranceDetails, PartnerDetails } from './insurance-details';
import { Component, OnInit, OnDestroy, NgZone, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderService, Header } from '../../common/header/header.service';
import { FooterService, Footer } from '../../common/footer/footer.service';
import { LoaderService, Loader } from '../../common/loader/loader.service';
import { ApplicationService } from '../../application/application.service';
import { LoanAgreementService } from './loan-agreement.service';
import { AwsTrackingService } from '../../common/tracking/aws-tracking.service';
import { AwsTracker, Level } from '../../common/tracking/aws-tracker';
import { TokenService } from '../../token/token.service';
import { Application } from '../application';
import { DocumentsService } from '../../customer/documents/documents.service';
import { OtpPurpose } from '../../authentication/authentication/authentication';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { EmailMobileService } from '../../customer/email-mobile/email-mobile.service';
import { environment } from 'environments/environment';
import { RepaymentDayDetails, SanctionLetter, LenderDetails } from './repayment-day-details';
import { DateSuffixPipe } from 'app/common/pipes';
import { DeviceDetectService } from 'app/common/device-detect/device-detect.service';

declare var $: any;
declare var Materialize: any;

@Component({
  selector: 'zest-loan-agreement',
  templateUrl: './loan-agreement.component.html',
  styleUrls: ['./loan-agreement.component.scss']
})
export class LoanAgreementComponent implements OnInit, AfterViewInit, OnDestroy {

  public loanAgreement = '';
  public showThirdPartyConsent = false;
  public showIncomeConsent = false;
  public acceptAgreement = false;
  public processing = false;
  public application: Application;
  public otp_number = '';
  public otpMask = {
    mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
    guide: false
  };
  public phone: number;
  public merchantName: string;

  public insurancePartner: any = new PartnerDetails();
  public insuranceCheck = true;
  public authorizeLoanContext = true;
  public thirdPartyConsent: any;
  public incomeConsent: any;
  public insuranceHead = '';
  public insuranceBody = '';
  public s3BucketUrl = environment.s3BucketUrl;
  public insuranceAmount: number;
  public repaymentDays = [];
  public emiHelpText = '';
  public isDesktop: boolean;
  public downloadString = '';
  public lenderString = '';
  public inPrincipleString = '';
  public disbursalComplianceString = '';
  public disableAcceptButton = false;
  public sanctionLetter: SanctionLetter;
  public lenderDetails: LenderDetails;
  public BasketAmount = 0;
  public NumberOfInstallments = 0;

  private remainingTime = 0;
  private loanAgreementOtpTimer: NodeJS.Timer;
  public pageTracker: AwsTracker;
  public otpId: string;
  private incorrectOtpAttempts = 0;
  private dateSuffixPipe: any;
  public insuranceFeePercentage: number;
  private restructuredApplication = false;
  public contextJSON: any;

  constructor(
    public headerService: HeaderService,
    public footerService: FooterService,
    public emailMobileService: EmailMobileService,
    public authenticationService: AuthenticationService,
    public awsTrackingService: AwsTrackingService,
    public loaderService: LoaderService,
    public tokenService: TokenService,
    public applicationService: ApplicationService,
    public loanAgreementService: LoanAgreementService,
    public router: Router,
    public deviceService: DeviceDetectService,
    public zone: NgZone,
    public documentsService: DocumentsService) {
    this.dateSuffixPipe = new DateSuffixPipe();
  }

  ngOnInit(restructuredApplication = false) {
    this.restructuredApplication = restructuredApplication;
    const application = this.applicationService.getApplication();
    this.loanAgreementService.getComplianceFeatureSwitch().subscribe(complianceSwitch => {
      if (complianceSwitch.showComplianceConsent) {
        this.loanAgreementService.getComplianceConsent().subscribe(complianceConsentResponse => {
          this.showThirdPartyConsent = !complianceConsentResponse.isDataSharingConsentSubmitted;
          this.showIncomeConsent = !complianceConsentResponse.isHouseHoldIncomeConsentSubmitted;
          if (this.showThirdPartyConsent || this.showIncomeConsent) {
            this.disableAcceptButton = true;
          }
        });
      }
    });
    this.BasketAmount = (application && application.BasketAmount) ? application.BasketAmount : 0;
    this.NumberOfInstallments = (application && application.NumberOfInstallments) ? application.NumberOfInstallments : 0;
    if (this.restructuredApplication) {
      const event = new EventDetails('rs_restructure_la_shown', 'page', 'load');
      this.awsTrackingService.sendDataToFunnel(event);
    }
    const states = this.applicationService.getPreapproveStates();
    if (states && !states.loan.IsLoanAgreementAccepted) {
      this.headerService.ShowHeaderSource.next(new Header(1, true, 50, false, 'Verify', false));
      this.footerService.ShowFooterSource.next(new Footer(false, false, false, false, false, true));
      this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
      this.getLoanAgreement();
      this.getRepaymentDays();
      this.getSanctionLetter();
    } else {
      this.applicationService.goToNextRoute(this.router.url);
    }
    this.isDesktop = this.deviceService.isDesktop();

  }

  ngAfterViewInit() {
    setTimeout(fn => {
      this.toggleLoanAgreementModal('open');
    }, 0);
  }

  ngOnDestroy() {
    clearTimeout(this.loanAgreementOtpTimer);
  }

  getSanctionLetter() {
    this.loanAgreementService.getSanctionLetter(this.applicationService.getApplicationId()).subscribe(
      response => {
        this.sanctionLetter = Object.assign({}, response);
        this.downloadString = '<span class="download-text">Download my sanction letter</span>';
        const lenderID = response.lenderId;
        this.loanAgreementService.getLender(lenderID).subscribe(
          response => {
            this.lenderDetails = Object.assign({}, response);
            this.lenderString = `<p>This loan is powered by <strong>${this.lenderDetails.registeredName}<strong></p>`;
            this.inPrincipleString = `<p>This is an in-principle letter subject to T&Cs</p>`;
            this.disbursalComplianceString = '<p>This Sanction Letter may not be construed as a binding commitment on us to disburse the above mentioned credit facility, unless you have accepted the standard loan terms in a form and manner acceptable to us and the conditions for disbursal set out therein are fulfilled to our satisfaction.</p>';
            this.trackLAPageLoad();
          }, error => {
            this.trackLAPageLoad();
          });
      }, error => {
        this.trackLAPageLoad();
      });
  }

  trackLAPageLoad() {
    const event = new EventDetails('LA', 'page', 'loaded', '');
    let props = this.awsTrackingService.setGlobalCustomProps();
    const additionalProps = {
      LenderName: this.lenderDetails ? this.lenderDetails.registeredName : ''
    };
    props = { ...props, ...additionalProps };
    this.awsTrackingService.sendDataToFunnelWithCustomProperties(event, props).subscribe();
  }

  getRepaymentDays() {
    this.loanAgreementService.getRepaymentsDays(this.applicationService.getMerchantId()).subscribe(response => {
      this.repaymentDays = response;
      if (this.repaymentDays && this.repaymentDays.length > 0) {
        this.emiHelpText = 'Your EMI due date will automatically be set to <b>' + this.dateSuffixPipe.transform(this.repaymentDays[0]) + ' of every month</b>';
      }
    });
  }

  saveRepaymentDay() {
    const repaymentDay = this.repaymentDays && this.repaymentDays.length >= 1 ? this.repaymentDays[0] : null;
    if (repaymentDay) {
      this.loanAgreementService.setRepaymentsDay(new RepaymentDayDetails(this.tokenService.getCustomerId(), this.applicationService.getApplicationId(), repaymentDay)).subscribe();
    }
  }

  getInsuranceDoc(e, value) {
    this.loanAgreementService.getInsuranceDetails(value).subscribe(response => {
      this.toggleLoanAgreementModal('close');
      setTimeout(fn => { this.insuranceBody = response['data']; }, 0);
    });
    e.preventDefault();
  }
  showAgreementInfo(event) {
    this.toggleLoanAgreementModal('close');
    this.toggleAgreementInfo('open');
    event.preventDefault();
  }
  closeAgreementInfo(event) {
    this.toggleLoanAgreementModal('open');
    this.toggleAgreementInfo('close');
    event.preventDefault();
  }

  toggleAgreementInfo(state: string) {
    $('#agreementInfoModal').modal(state);
  }

  toggleLoanAgreementModal(state: string) {
    $('#loanAgreementModal').modal(state);
  }

  getInsuranceAvailability() {
    const application = this.applicationService.getApplication();
    this.loanAgreementService.getInsuranceAvailability(application.MerchantId, application.ApplicationId).subscribe(
      response => {
        this.insurancePartner = response;
        this.insurancePartner.merchantName = application.MerchantName;
        this.loanAgreementService.getInsuranceAmount(application.ApplicationId, this.insurancePartner.partnerId, application.MerchantId)
          .subscribe(response => {
            const { insuranceFee, feePercentage } = response.data;
            this.insuranceAmount = insuranceFee;
            this.insuranceFeePercentage = feePercentage;
          }, error => {
            this.insuranceAmount = 0;
          });
      }, error => this.insurancePartner = new PartnerDetails()
    );
  }

  clearError(event) {
    this.insuranceBody = '';
    this.insuranceHead = '';
    setTimeout(fn => {
      this.toggleLoanAgreementModal('open');
    }, 0);
  }

  startSanctionLetterDownload($event) {
    $event.preventDefault();
    const event = new EventDetails('ViewAction', 'click', 'triggered');
    const props = {
      Action: 'SanctionLetterDownload',
      View: 'LA'
    };
    this.awsTrackingService.sendDataToFunnelWithCustomProperties(event, props);
    const sanctionLetterPDFContent = this.sanctionLetter.content;
    this.documentsService.downloadFileFromBase64String('SanctionLetter.pdf', 'application/pdf', sanctionLetterPDFContent);
  }

  getLoanAgreement() {
    this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
    this.application = this.applicationService.getApplication();
    this.loanAgreementService.getLoanAgreement(this.applicationService.getMerchantId(), this.applicationService.getApplicationId()).subscribe(response => {
      this.loanAgreement = response;
      this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
      this.pageTracker = new AwsTracker(Level.Page, 'LoanAgreement_Page');
      this.awsTrackingService.gtmPageLoadEvent('LA-Page-Loaded');
      this.getInsuranceAvailability();
    }, error => {
      this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
      this.pageTracker = new AwsTracker(Level.Page, 'LoanAgreement_Page');
      const event = new EventDetails('Loan_Agreement_loaded', 'page', 'loaded', '');
      this.awsTrackingService.sendDataToFunnel(event).subscribe();
    });
  }
  getConsentValue(val) {
    this.insuranceCheck = val;
  }
  checkInsuranceFacility() {
    const toggle = this.insuranceCheck ? 'On' : 'Off';
    const eventName = this.insuranceCheck ? 'LA-InsuranceOptIn' : 'LA-InsuranceOptout';
    const event = new EventDetails('ViewAction', 'click', 'triggered');
    const props = {
      Action: `InsuranceToggle${toggle}`,
      View: 'LA'
    };
    this.awsTrackingService.sendDataToFunnelWithCustomProperties(event, props);
    const insuranceEvent = new EventDetails(eventName, 'click', 'triggered');
    const insuranceProps = {
      MerchantName: this.insurancePartner ? this.insurancePartner.merchantName : '',
      InsurerName: this.insurancePartner ? this.insurancePartner.partnerName : '',
      InsuranceAmount: this.insuranceAmount
    };
    this.awsTrackingService.sendDataToFunnelWithCustomProperties(insuranceEvent, insuranceProps);
    if (!this.insuranceCheck) {
      this.toggleLoanAgreementModal('close');
      this.toggleConfirmInsuranceOptout('open');

    }
  }
  saveAuthorizeContext($event) {
    if (this.authorizeLoanContext) {
      this.disableAcceptButton = true;
      Materialize.toast('Please opt-in the consent to accept the loan agreement', 5000, 'rounded', () => { this.tokenService.removeAllToasts(); });
    } else {
      this.disableAcceptButton = false;
      this.tokenService.removeAllToasts();
    }
  }

  closeInsurancePopup(state) {
    // this.insuranceCheck = true;
    this.toggleConfirmInsuranceOptout(state);
  }

  toggleConfirmInsuranceOptout(state) {
    if (state === 'open') {
      const ctaEvent = new EventDetails('ViewVisited', 'page', 'loaded');
      const props = {
        Context: 'LA',
        LastAction: 'InsuranceToggleoff',
        View: 'InsurancePop-up'
      };
      this.awsTrackingService.sendDataToFunnelWithCustomProperties(ctaEvent, props);
    } else {
      this.toggleLoanAgreementModal('open');
    }
    $('#confirm-insurance-optout').modal(state);
  }
  confirmInsuranceOptout(optout) {
    const toggle = optout ? 'Yes' : 'No';
    const event = new EventDetails('ViewAction', 'event', 'triggered');
    const props = {
      Action: toggle,
      View: 'InsurancePop-up'
    };
    this.awsTrackingService.sendDataToFunnelWithCustomProperties(event, props);
    if (optout) {
      this.toggleConfirmInsuranceOptout('close');
      this.toggleLoanAgreementModal('open');
    } else {
      this.insuranceCheck = true;
      this.toggleConfirmInsuranceOptout('close');
      this.toggleLoanAgreementModal('open');
    }
  }
  saveLoanAgreement() {
    this.saveRepaymentDay();
    this.awsTrackingService.sendData(this.pageTracker, this.applicationService.getApplicationId(), this.tokenService.getCustomerId()).subscribe();
    this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
    this.processing = true;
    if ((this.showThirdPartyConsent && this.thirdPartyConsent) || (this.showIncomeConsent && this.incomeConsent)) {
      this.loanAgreementService.saveComplianceConsent({thirdPartyConsent: this.thirdPartyConsent, incomeConsent: this.incomeConsent}).subscribe(() => {
        const event = new EventDetails('Compliance_Consent', 'event', 'triggered', '');
        let props = this.awsTrackingService.setGlobalCustomProps();
        const additionalProps = {
          source: 'Checkout-Preapprove'
        };
        props = { ...props, ...additionalProps };
        this.awsTrackingService.sendDataToFunnelWithCustomProperties(event, props).subscribe();
        this.saveAgreement();
      }, error => {
          const event = new EventDetails('Compliance_Consent_failed', 'event', 'triggered', '');
          this.awsTrackingService.sendDataToFunnel(event).subscribe();
          this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
          this.processing = false;
      });
    } else {
      this.saveAgreement();
    }
    if (this.insurancePartner.partnerId) {
      const insuranceDetails = new InsuranceDetails(this.tokenService.getCustomerId(), this.applicationService.getApplicationId(), this.applicationService.getMerchantId(), this.insurancePartner.partnerId, this.insuranceCheck);
      this.loanAgreementService.setInsuranceAgreement(insuranceDetails).subscribe();
    }
  }
  saveAgreement() {
    const applicationId = this.applicationService.getApplicationId();
    this.applicationService.changeApplicationStatus('LoanAgreementAccepted', applicationId, null, null, this.otpId).subscribe(response => {
      this.awsTrackingService.gtmTriggerEvent('LA-Accepted');
      const event = new EventDetails('PrimaryCTA', 'click', 'triggered');
      const props = {
        Action: 'IAccept',
        Context: 'LA'
      };
      this.awsTrackingService.sendDataToFunnelWithCustomProperties(event, props);
      this.toggleLoanAgreementModal('close');
      this.applicationService.goToNextRoute(this.router.url);
    }, error => {
      const event = new EventDetails('Loan_Agreement_submit_failed', 'event', 'triggered', '');
      this.awsTrackingService.sendDataToFunnel(event).subscribe();
      this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
      this.processing = false;
    });
  }
  triggerLoanAgreementOtp() {
    this.processing = true;
    this.incorrectOtpAttempts = 0;
    this.emailMobileService.getMobile().subscribe(response => {
      this.phone = Number(response.PhoneNumber.substring(2));
    });
    this.authenticationService.generateOtp(this.tokenService.getCustomerId(), this.applicationService.getApplicationId(), OtpPurpose.DocumentSignature).subscribe(response => {
      this.otpId = response.OtpId;
      this.toggleLoanAgreementModal('close');
      this.toggleOTPModal(true);
      this.processing = false;
    }, error => {
      this.processing = false;
      this.tokenService.removeAllToasts();
      Materialize.toast('Something went wrong. Please try again.', 5000, 'rounded', () => { this.tokenService.removeAllToasts(); });
    });
  }
  verifyLoanAgreementOtp() {
    this.processing = true;
    this.authenticationService.verifyOtp(this.otpId, this.otp_number).subscribe(response => {
      this.toggleOTPModal(false);
      this.saveLoanAgreement();
    }, error => {
      this.processing = false;
      this.incorrectOtpAttempts = this.incorrectOtpAttempts + 1;
      this.tokenService.removeAllToasts();
      if (this.incorrectOtpAttempts === 3) {
        Materialize.toast('Your OTP is expired. Please click on Resend OTP and try again.', 5000, 'rounded', () => { this.tokenService.removeAllToasts(); });
      } else {
        Materialize.toast('Invalid OTP. Please try again.', 5000, 'rounded', () => { this.tokenService.removeAllToasts(); });
      }
    });
  }
  resendLoanAgreementOtp() {
    this.processing = true;
    this.incorrectOtpAttempts = 0;
    this.authenticationService.generateOtp(this.tokenService.getCustomerId(), this.applicationService.getApplicationId(), OtpPurpose.DocumentSignature).subscribe(response => {
      this.otpId = response.OtpId;
      this.startTimer();
      this.processing = false;
    }, error => {
      this.processing = false;
      this.tokenService.removeAllToasts();
      Materialize.toast('Something went wrong. Please try again.', 5000, 'rounded', () => { this.tokenService.removeAllToasts(); });
    });
  }
  toggleOTPModal(open: boolean) {
    setTimeout(fn => {
      $('#otp-generator.modal').modal();
      $('#otp-generator').modal(open ? 'open' : 'close');
    }, 0);
    this.otp_number = '';
  }
  startTimer() {
    this.remainingTime = 30;
    this.loanAgreementOtpTimer = setInterval(() => {
      if (this.remainingTime <= 0) {
        clearInterval(this.loanAgreementOtpTimer);
      }
      this.remainingTime--;
    }, 1000);
  }


  triggerConsentModal(state) {
    if (state === 'open') {
      this.loanAgreementService.getConsentPopupData().subscribe(res => {
        this.contextJSON = res;
        setTimeout(fn => { $('#incomeConsentModal').modal('open'); }, 0);
      });
    } else {
      setTimeout(fn => { $('#incomeConsentModal').modal('close'); }, 0);
    }
  }

  checkConsent() {
    if (this.authorizeLoanContext) {
      if (this.showThirdPartyConsent && this.showIncomeConsent && this.thirdPartyConsent && this.incomeConsent) {
        this.disableAcceptButton = false;
      } else if (!this.showIncomeConsent && this.showThirdPartyConsent && this.thirdPartyConsent) {
        this.disableAcceptButton = false;
      } else if (!this.showThirdPartyConsent && this.showIncomeConsent && this.incomeConsent) {
        this.disableAcceptButton = false;
      } else if (!this.showThirdPartyConsent && !this.showIncomeConsent) {
        this.disableAcceptButton = false;
      } else {
        this.disableAcceptButton = true;
      }
    }
  }

  redirectToConsent() {
    window.open(environment.cmsUrl, '_blank');
  }
}
